<template>
  <!-- Content Left Rail -->
  <v-sheet class="settings-left-nav">
    <v-list-item-title class="settings-nav-title font-weight-medium"
      >Settings</v-list-item-title
    >
    <v-list dense nav>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('account')"
        @click="navigateTo('account')"
        v-if="$root.$children[0].isAdmin"
      >
        Account
      </v-list-item>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('personal')"
        @click="navigateTo('personal')"
      >
        Personal
      </v-list-item>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('users')"
        @click="navigateTo('users')"
        v-if="$root.$children[0].isAdmin"
      >
        Users
      </v-list-item>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('customers')"
        @click="navigateTo('customers')"
        v-if="$root.$children[0].isAdmin"
      >
        Customers
      </v-list-item>

      <!-- <v-list-item class="subtitle-1" v-if="$root.$children[0].isAdmin">
        Calls/Texts
      </v-list-item>
      <v-list-item
        class="body-2 pl-12 pr-1"
        :class="routeColor('telecom-fwd')"
        @click="navigateTo('telecom-fwd')"
        v-if="$root.$children[0].isAdmin"
      >
        Forwarding Numbers
      </v-list-item>
      <v-list-item
        class="body-2 pl-12 pr-1"
        :class="routeColor('telecom-trck')"
        @click="navigateTo('telecom-trck')"
        v-if="$root.$children[0].isAdmin"
      >
        Tracking Numbers
      </v-list-item>
      <v-list-item
        class="body-2 pl-12 pr-1"
        :class="routeColor('telecom-flow')"
        @click="navigateTo('telecom-flow')"
        v-if="$root.$children[0].isAdmin"
      >
        Call Flows
      </v-list-item> -->

      <!-- <v-list-item class="subtitle-1" @click="navigateTo('messages')">
        Messages
      </v-list-item> -->
      <!-- <v-list-item class="subtitle-1" @click="navigateTo('chats')">
        Chats
      </v-list-item> -->
      <!-- <v-list-item class="subtitle-1" @click="navigateTo('bots')">
        Bots
      </v-list-item> -->
      <v-list-item
        class="subtitle-1 left-nav"
        @click="navigateTo('list')"
        v-if="$root.$children[0].isAdmin && ENVIRONMENT_NAME == 'dev'"
      >
        Lists
      </v-list-item>
    </v-list>
  </v-sheet>
</template>

<script>
import { ENVIRONMENT_NAME } from "../../globalVars";

export default {
  name: "SettingsLeftNavigation",
  props: {
    msg: String
  },
  data: function() {
    return {
      ENVIRONMENT_NAME,
      toggleFilter: 1,
      selectedItem: null
    };
  },
  created() {},
  watch: {},
  computed: {},
  methods: {
    navigateTo(settingType) {
      this.$parent.$parent.$parent.settingsNavSelected = settingType;
      this.$root.$children[0].navMenuOpen = false;
    },
    routeColor(routeName) {
      return this.$parent.$parent.$parent.settingsNavSelected == routeName
        ? "font-weight-medium"
        : "font-weight-normal";
    }
  }
};
</script>

<style scoped lang="stylus">
.settings-left-nav {
  padding-top: 1rem;
}
div.settings-left-nav, div.settings-left-nav div {
  background-color: rgb(241, 241, 241);
  width: 100%;
}
.settings-left-nav div.v-list {
  padding: 0;
}
.settings-nav-title {
  padding: 1.5rem 2rem 0.5rem;
  font-size: 1.1rem;
  font-weight: 500;
  text-transform: uppercase;
}
.subtitle-1 {
  font-size: 1rem;
  font-weight: 400;
}
.v-list-item.left-nav {
  padding: .5rem 2rem;
}
</style>
